export const getSingleAdvertData = (payload?: any) => ({
    type: "@saga/GET_SINGLE_ADVERT_DATA",
    payload
});

